<template>
    <footer id="footer" v-if="datos_site">
        <div class="container" v-if="datos_site">
            <p v-if="datos_site.footer_texto" class="px-4 mb-4 text-start">{{ datos_site.footer_texto }}</p>
            <div class="row">
                <div class="col-md-3">
                    <div class="">
                        <img class="img-fluid" src="/assets/images/logofooter.png" />
                    </div>
                </div>
                <div class="col-md-9">
                    <div class="middle-column d-flex flex-column">
                        <div class="p-2 text-white text-start">
                            <div class="row">
                                <div class="col-md-6">
                                    <ul class="list-unstyled">
                                        <li v-if="info && info.direccion" class="d-flex align-items-start mb-3">
                                            <i class="ri-map-pin-line me-2"></i> 
                                            <span v-html="nlToBr(info.direccion)"></span>
                                        </li>
                                        <li v-if="info && info.telefono1" class="d-flex align-items-start mb-3">
                                            <i class="ri-phone-line me-2"></i>
                                            <span>{{ info.telefono1 }}</span>
                                        </li>
                                        <li v-if="info && info.email" class="d-flex align-items-start mb-3">
                                            <i class="ri-mail-line me-2"></i>
                                            <span>{{ info.email }}</span>
                                        </li>
                                    </ul>
                                    <div class="social-links p-2 mt-auto text-white text-center">
                                        <a v-if="datos_site.footer_link_twitter" :href="datos_site.footer_link_twitter" class="twitter" target="_blank">
                                            <i class="bx bxl-twitter"></i>
                                        </a>
                                        <a v-if="datos_site.footer_link_facebook" :href="datos_site.footer_link_facebook" class="facebook" target="_blank">
                                            <i class="bx bxl-facebook"></i>
                                        </a>
                                        <a v-if="datos_site.footer_link_instagram" :href="datos_site.footer_link_instagram" class="instagram" target="_blank">
                                            <i class="bx bxl-instagram"></i>
                                        </a>
                                        <a v-if="datos_site.footer_link_linkedin" :href="datos_site.footer_link_linkedin" class="linkedin" target="_blank">
                                            <i class="bx bxl-linkedin"></i>
                                        </a>
                                        <a v-if="datos_site.footer_link_youtube" :href="datos_site.footer_link_youtube" class="youtube" target="_blank">
                                            <i class="bx bxl-youtube"></i>
                                        </a>
                                        <a v-if="datos_site.footer_link_flickr" :href="datos_site.footer_link_flickr" class="flickr" target="_blank">
                                            <i class="bx bxl-flickr"></i>
                                        </a>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div v-if="contacto_areas" v-for="contacto of contacto_areas" v-bind:key="contacto.id_contacto" class="areas">
                                        <h5 class="m-0">{{ contacto.area }}</h5>
                                        <p v-if="contacto.direccion"><span class="ri-map-pin-fill"></span> {{ contacto.direccion }}</p>
                                        <p v-if="contacto.telefono"><span class="ri-phone-fill"></span> {{ contacto.telefono }}</p>
                                        <p v-if="contacto.email"><span class="ri-mail-fill"></span> <a :href="'mailto:'+ contacto.email">{{ contacto.email }}</a></p>
                                        <p v-if="contacto.whatsapp"><span class="ri-whatsapp-fill"></span> <a :href="'https://wa.me/'+ contacto.whatsapp + '?text='" target="_BLANK">{{ contacto.whatsapp }}</a></p>
                                        <p v-if="contacto.horario"><span class="ri-clock-fill"></span> {{ contacto.horario }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <hr>
        <div class="container">
            <div class="credits">
                <div class="d-flex justify-content-between">
                    <span class="text-start"><span v-if="datos_site.institucional_titulo">{{ datos_site.institucional_titulo }}</span> &copy; Copyright <strong><span v-if="datos_site.site_name">{{ datos_site.site_name }}</span></strong>. All Rights Reserved</span>
                    <span class="text-end"><a href="https://soportegmc.wixsite.com/capra">Soluciones Informáticas Capra</a> Powered by <a href="https://lemonsystems.com.ar/">Lemonsystems</a></span>
                </div>
            </div>
        </div>
    </footer>
    
</template>

<script>
import { useStore } from 'vuex'
import { computed } from 'vue'
import { nlToBr } from '../utils/common.utils.js'

export default{
    name: 'FooterComponent',
    components: {
    },
    setup(){
        const store = useStore()
        const datos_site = computed(() => store.state.datos.site)
        const contacto_areas = computed(() => store.state.datos.contacto_areas)
        const info = computed(() => store.state.datos.data)
        return {datos_site, contacto_areas, info, nlToBr}
    }
}
</script>
